// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import assign from 'lodash/assign';
import get from 'lodash/get';

function determineSubscribe(
  currentlySubscribedTo,
  id,
  nlState,
  toSubscribe,
  toUnsubscribe
) {
  const currVal = nlState[id]; // true or false
  const isAlreadySubscribed = currentlySubscribedTo.indexOf(id) !== -1;
  const updatedUnsubscribed = toUnsubscribe.slice(0);
  const updatedToSubscribe = toSubscribe.slice(0);

  if (isAlreadySubscribed && currVal) {
    // add id to unsubscribe list
    updatedUnsubscribed.push(id);
  }

  if (isAlreadySubscribed && !currVal) {
    // remove id from unsubscribe list
    updatedUnsubscribed.splice(updatedUnsubscribed.indexOf(id), 1);
  }

  if (!isAlreadySubscribed && currVal) {
    // remove id to subscribe list
    updatedToSubscribe.splice(updatedToSubscribe.indexOf(id), 1);
  }

  if (!isAlreadySubscribed && !currVal) {
    // add id to subscribe list
    updatedToSubscribe.push(id);
  }

  return { subscribe: updatedToSubscribe, unsubscribe: updatedUnsubscribed };
}

function determineSubscribeForRadio(
  idToSubscribe,
  idsToUnsubscribe,
  toSubscribe,
  toUnsubscribe
) {
  const updatedToSubscribe = [...toSubscribe, idToSubscribe];
  const updatedUnsubscribed = [...toUnsubscribe, ...idsToUnsubscribe];

  return { subscribe: updatedToSubscribe, unsubscribe: updatedUnsubscribed };
}

function pruneLists(previousState, subscribe, unsubscribe) {
  unsubscribe.forEach(listId => {
    previousState.splice(previousState.indexOf(listId), 1);
  });
  return previousState.concat(subscribe);
}

export default function(state = {}, action) {
  const typeMap = {
    NEWSLETTERS_PREFERENCES_PAGE_LOADING() {
      return {
        isLoading: true,
        newslettersPreferencesPage: action.newslettersPreferencesPage
      };
    },
    NEWSLETTERS_PREFERENCES_PAGE_LOADED() {
      const baseNewsletterLookup = action.store.getState().config.newsletters
        .listsById;
      const allNewsletterIds = action.store.getState().config.newsletters
        .allIds;
      const allNewsletters = allNewsletterIds.map(key => {
        const found = baseNewsletterLookup[key];

        return assign({}, found, {
          listId: key
        });
      });

      return {
        isLoading: false,
        data: action.newslettersPreferencesPage,
        subscribe: [],
        unsubscribe: [],
        emailEditable: false,
        allNewsletterIds,
        allNewsletters,
        masterLookup: baseNewsletterLookup,
        allNewslettersSelected: assign(
          ...allNewsletterIds.map(id => ({
            [id]:
              action.newslettersPreferencesPage.lists.indexOf(Number(id)) !== -1
          }))
        )
      };
    },
    NEWSLETTERS_PREFERENCES_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.newslettersPreferencesPage.errorMessage
      };
    },
    CHANGE_NEWSLETTER_PREFERENCES_RADIO() {
      const newNewsletterId = action.data.selectedListId;
      const { radioSet } = action.data;
      const toUnsubscribe = radioSet.filter(id => id !== newNewsletterId);

      const subscribeLists = determineSubscribeForRadio(
        newNewsletterId,
        toUnsubscribe,
        state.subscribe,
        state.unsubscribe
      );

      const newSelectionState = {
        [newNewsletterId]: true
      };

      toUnsubscribe.forEach(id => {
        newSelectionState[id] = false;
      });

      return assign(
        {},
        state,
        {
          allNewslettersSelected: assign(
            {},
            state.allNewslettersSelected,
            newSelectionState
          )
        },
        subscribeLists
      );
    },
    CHANGE_NEWSLETTER_PREFERENCES() {
      const currentlySubscribedTo = state.data.lists;
      const newNewsletterId = action.data.id;
      const currentSelectionState = state.allNewslettersSelected;
      const subscribeLists = determineSubscribe(
        currentlySubscribedTo,
        newNewsletterId,
        currentSelectionState,
        state.subscribe,
        state.unsubscribe
      );
      return assign(
        {},
        state,
        {
          allNewslettersSelected: assign({}, state.allNewslettersSelected, {
            [newNewsletterId]: !currentSelectionState[newNewsletterId]
          })
        },
        subscribeLists
      );
    },
    UPDATE_NEWSLETTER_PREFERENCES_SUCCESS() {
      return assign({}, state, {
        isLoading: false,
        unsubscribe: [],
        subscribe: [],
        subscriptionUpdateSuccessMessage:
          'Your subscriptions have been updated!',
        data: assign({}, state.data, {
          lists: pruneLists(
            state.data.lists,
            state.subscribe,
            state.unsubscribe
          )
        })
      });
    },
    PREPARE_EMAIL_FIELD_FOR_CHANGE() {
      return assign({}, state, {
        emailEditable: !state.emailEditable
      });
    },
    UPDATE_SUBSCRIPTION_EMAIL_SUCCESS() {
      return assign({}, state, {
        emailEditable: false,
        data: Object.assign({}, state.data, { email: action.data.email }),
        emailUpdateSuccessMessage: 'Email change sucessful!'
      });
    },
    UPDATE_SUBSCRIPTION_EMAIL_ERROR() {
      return assign({}, state, {
        emailUpdateMessageError: get(action, 'data', '')
      });
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
